"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alias = void 0;
const marshall_1 = require("@waves/marshall");
const ts_lib_crypto_1 = require("@waves/ts-lib-crypto");
const proto_serialize_1 = require("../proto-serialize");
const generic_1 = require("../generic");
const validators_1 = require("../validators");
const defaultVersions_1 = require("../defaultVersions");
const ts_types_1 = require("@waves/ts-types");
function alias(paramsOrTx, seed) {
    const type = ts_types_1.TRANSACTION_TYPE.ALIAS;
    const version = paramsOrTx.version || defaultVersions_1.DEFAULT_VERSIONS.ALIAS;
    const seedsAndIndexes = generic_1.convertToPairs(seed);
    const senderPublicKey = generic_1.getSenderPublicKey(seedsAndIndexes, paramsOrTx);
    const tx = {
        type,
        version,
        senderPublicKey,
        alias: paramsOrTx.alias,
        fee: generic_1.fee(paramsOrTx, 100000),
        feeAssetId: generic_1.normalizeAssetId(paramsOrTx.feeAssetId),
        timestamp: paramsOrTx.timestamp || Date.now(),
        chainId: generic_1.networkByte(paramsOrTx.chainId, 87),
        proofs: paramsOrTx.proofs || [],
        id: '',
    };
    validators_1.validate.alias(tx);
    const bytes = version > 2 ? proto_serialize_1.txToProtoBytes(tx) : marshall_1.binary.serializeTx(tx);
    const idBytes = version > 2 ? bytes : [bytes[0], ...bytes.slice(36, -16)];
    seedsAndIndexes.forEach(([s, i]) => generic_1.addProof(tx, ts_lib_crypto_1.signBytes(s, bytes), i));
    tx.id = ts_lib_crypto_1.base58Encode(ts_lib_crypto_1.blake2b(Uint8Array.from(idBytes)));
    return tx;
}
exports.alias = alias;
//# sourceMappingURL=alias.js.map